var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "sopWorkTaskBoard",
      staticClass: "sop-work-task-board",
      staticStyle: { position: "relative" }
    },
    [
      _c(
        "div",
        { staticClass: "sop-tab", class: { mask: _vm.showLayer } },
        [
          _c(
            "el-tabs",
            {
              attrs: { value: _vm.lob, lazy: true },
              on: {
                input: _vm.onLobInput,
                "tab-click": function($event) {
                  return _vm.lobChange(true)
                }
              }
            },
            _vm._l(_vm.businessTypes, function(item) {
              return _c(
                "el-tab-pane",
                {
                  key: item.name,
                  staticClass: "tab-pane-wrapper",
                  attrs: { label: item.label, name: item.name }
                },
                [
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-wrap": "wrap",
                          "background-color": "white"
                        }
                      },
                      _vm._l(_vm.nodePriorityStatistics, function(
                        nodePriorityInfo,
                        index
                      ) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class: nodePriorityInfo.selected
                              ? "node-selected"
                              : "node-default",
                            staticStyle: {
                              "border-style": "solid",
                              "border-radius": "3%",
                              width: "226px",
                              height: "90px",
                              "margin-left": "10px",
                              "box-shadow": "0 0 5px #bad7ed",
                              "margin-top": "12px",
                              "margin-bottom": "12px",
                              cursor: "pointer"
                            },
                            on: {
                              click: function($event) {
                                return _vm.nodeSelected(nodePriorityInfo)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center"
                                }
                              },
                              [
                                _c("div", { staticClass: "tab-guide-item" }, [
                                  nodePriorityInfo.icon
                                    ? _c("img", {
                                        attrs: {
                                          src: nodePriorityInfo.icon,
                                          width: "22",
                                          height: "22",
                                          alt: ""
                                        }
                                      })
                                    : _vm._e(),
                                  !nodePriorityInfo.icon
                                    ? _c(
                                        "div",
                                        [
                                          _vm.lob === "SI" || _vm.lob === "SE"
                                            ? _c("svg-icon", {
                                                staticClass: "svg-common",
                                                staticStyle: {
                                                  "margin-right": "0px"
                                                },
                                                attrs: {
                                                  "icon-class": "sop-sea"
                                                }
                                              })
                                            : _vm.lob === "AI" ||
                                              _vm.lob === "AE"
                                            ? _c("svg-icon", {
                                                staticClass: "svg-common",
                                                staticStyle: {
                                                  "margin-right": "0px"
                                                },
                                                attrs: {
                                                  "icon-class": "sop-air"
                                                }
                                              })
                                            : _c("svg-icon", {
                                                staticClass: "svg-common",
                                                staticStyle: {
                                                  "margin-right": "0px"
                                                },
                                                attrs: {
                                                  "icon-class": "sop-land"
                                                }
                                              })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]),
                                _c("span", {
                                  staticClass: "underline-on-hover",
                                  staticStyle: {
                                    "align-items": "center",
                                    "margin-left": "13px",
                                    "font-size": "15px",
                                    color: "#3188cb",
                                    "font-weight": "bold",
                                    cursor: "pointer"
                                  },
                                  attrs: {
                                    title: _vm.enrichNodeTile(nodePriorityInfo)
                                  },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.enrichNodeName(nodePriorityInfo)
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.nodeSelected(nodePriorityInfo)
                                    }
                                  }
                                })
                              ]
                            ),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "10px" } },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-size": "15px" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_High"))
                                    )
                                  ]
                                ),
                                [
                                  nodePriorityInfo.enableHigh
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "underline-on-hover",
                                          staticStyle: {
                                            color: "red",
                                            "font-weight": "bold",
                                            "font-size": "15px",
                                            cursor: "pointer"
                                          },
                                          attrs: { title: "" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.nodeSelected(
                                                nodePriorityInfo,
                                                _vm.PRIORITY_HIGH.code
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.enrichNodeCount(
                                                nodePriorityInfo,
                                                _vm.PRIORITY_HIGH.code
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "red",
                                            "font-weight": "bold",
                                            "font-size": "15px"
                                          },
                                          attrs: { title: "" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.enrichNodeCount(
                                                nodePriorityInfo,
                                                _vm.PRIORITY_HIGH.code
                                              )
                                            )
                                          )
                                        ]
                                      )
                                ],
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-left": "10px",
                                      "font-size": "15px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Medium"))
                                    )
                                  ]
                                ),
                                [
                                  nodePriorityInfo.enableMedium
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "underline-on-hover",
                                          staticStyle: {
                                            color: "#e4a952",
                                            "font-weight": "bold",
                                            "font-size": "15px",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.nodeSelected(
                                                nodePriorityInfo,
                                                _vm.PRIORITY_MEDIUM.code
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.enrichNodeCount(
                                                nodePriorityInfo,
                                                _vm.PRIORITY_MEDIUM.code
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#e4a952",
                                            "font-weight": "bold",
                                            "font-size": "15px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.enrichNodeCount(
                                                nodePriorityInfo,
                                                _vm.PRIORITY_MEDIUM.code
                                              )
                                            )
                                          )
                                        ]
                                      )
                                ],
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-left": "10px",
                                      "font-size": "15px"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Low")))]
                                ),
                                [
                                  nodePriorityInfo.enableLow
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "underline-on-hover",
                                          staticStyle: {
                                            color: "#0bae5b",
                                            "font-weight": "bold",
                                            "font-size": "15px",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.nodeSelected(
                                                nodePriorityInfo,
                                                _vm.PRIORITY_LOW.code
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.enrichNodeCount(
                                                nodePriorityInfo,
                                                _vm.PRIORITY_LOW.code
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#0bae5b",
                                            "font-weight": "bold",
                                            "font-size": "15px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.enrichNodeCount(
                                                nodePriorityInfo,
                                                _vm.PRIORITY_LOW.code
                                              )
                                            )
                                          )
                                        ]
                                      )
                                ]
                              ],
                              2
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                ],
                2
              )
            }),
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "absolute", right: "0", top: "0" } },
        [
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-right": "10px" },
              on: { change: _vm.sopNodeNoDataHideChangeHandle },
              model: {
                value: _vm.sopNodeNoDataHide,
                callback: function($$v) {
                  _vm.sopNodeNoDataHide = $$v
                },
                expression: "sopNodeNoDataHide"
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SOPPanelNoDataHide")))]
          ),
          _vm.templates &&
          _vm.templates.length > 1 &&
          !_vm.selectedTemplateMap.get(_vm.lob)
            ? _c("span", { staticStyle: { color: "#989999" } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("CargoMsg.Cargo_TemplateNodeMergeShow")) +
                    " "
                )
              ])
            : _vm._e(),
          _vm.selectedTemplateMap.get(_vm.lob)
            ? _c(
                "span",
                { staticStyle: { margin: "0px 5px", color: "#1F75D5" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.selectedTemplateMap.get(_vm.lob)
                        ? _vm.selectedTemplateMap.get(_vm.lob)["templateName"]
                        : null
                    )
                  )
                ]
              )
            : _vm._e(),
          _c(
            "el-popover",
            {
              attrs: { placement: "bottom-end" },
              model: {
                value: _vm.popVisible,
                callback: function($$v) {
                  _vm.popVisible = $$v
                },
                expression: "popVisible"
              }
            },
            [
              _c(
                "el-button",
                {
                  attrs: { slot: "reference", type: "primary" },
                  slot: "reference"
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("Message.SelectTemplate")) + " "),
                  _c("i", {
                    staticClass: "el-icon-arrow-down",
                    staticStyle: { color: "#CCCCCC" }
                  })
                ]
              ),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.templates,
                    border: "",
                    "row-class-name": _vm.onRowClassName
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("Template.TemplateName"),
                      width: "150"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    return _vm.onTemplateClick(row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(row.templateName))]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("CargoMsg.Cargo_DefaultOrNot") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("el-checkbox", {
                              attrs: { value: row.homepageDisplayOnUserWt },
                              on: {
                                input: function(val) {
                                  return _vm.onCheckInput(row, val)
                                }
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("el-divider", {
        staticStyle: {
          height: "2px",
          "background-color": "#E4E7ED",
          "margin-top": "15px",
          "margin-bottom": "15px"
        }
      }),
      _c(
        "sop-filter",
        {
          ref: "sopFilter",
          staticStyle: { "margin-bottom": "15px", display: "flex" },
          attrs: {
            lob: _vm.lob,
            "sop-templates": _vm.templates,
            "is-sales-for-szfs": _vm.isSalesForSzfs,
            "default-levels": _vm.toNumArray(_vm.defaultLevels)
          },
          on: { search: _vm.handleSearch }
        },
        [
          _c(
            "el-button",
            {
              attrs: { slot: "filter", no: "moreFilter", type: "primary" },
              on: {
                click: function($event) {
                  _vm.filterDialog.visible = true
                }
              },
              slot: "filter"
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MoreFilters")))]
          ),
          _c(
            "el-button",
            {
              attrs: { slot: "other", no: "editSopStatus", type: "success" },
              on: { click: _vm.editState },
              slot: "other"
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.EditSopStatus")))]
          ),
          _c(
            "template",
            { slot: "other" },
            _vm._l(_vm.tenantInstructions, function(tenantInstruction, index) {
              return _c(
                "div",
                { key: index },
                [
                  _vm.PLATFORM_INSTRUCTION_CODE_JUMP_PAGE.code !==
                  tenantInstruction.platformInstructionCode
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "5px" },
                          attrs: {
                            disabled:
                              (_vm
                                .PLATFORM_INSTRUCTION_CODE_LCL_SEND_DESTINATION_PORT_AGENT
                                .code ===
                                tenantInstruction.platformInstructionCode ||
                                _vm
                                  .PLATFORM_INSTRUCTION_CODE_LCL_SEND_PACKAGE_AGENT
                                  .code ===
                                  tenantInstruction.platformInstructionCode) &&
                              _vm.selectedRowsCount !== 0 &&
                              (_vm.selectedRowsCount !== 1 ||
                                !_vm.selectedRow.instructionUuids ||
                                _vm.selectedRow.instructionUuids.indexOf(
                                  tenantInstruction.uuid
                                ) <= -1),
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.batchInstructionClick(
                                tenantInstruction
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.ColumnUtils.instructionNameLabelFunc(
                                  tenantInstruction
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            0
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: {
                "line-height": "28px",
                "margin-left": "5px",
                "margin-right": "10px"
              },
              attrs: { slot: "other", disabled: _vm.onlyShowSlave },
              on: { change: _vm.onCollapseListChange },
              slot: "other",
              model: {
                value: _vm.collapseList,
                callback: function($$v) {
                  _vm.collapseList = $$v
                },
                expression: "collapseList"
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CollapseList")))]
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: {
                "line-height": "28px",
                "margin-left": "5px",
                "margin-right": "10px"
              },
              attrs: { slot: "other", disabled: _vm.collapseList },
              on: { change: _vm.onOnlyShowSlaveChange },
              slot: "other",
              model: {
                value: _vm.onlyShowSlave,
                callback: function($$v) {
                  _vm.onlyShowSlave = $$v
                },
                expression: "onlyShowSlave"
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.DisplayReceiptsOnly")))]
          )
        ],
        2
      ),
      _vm.lob === "SE"
        ? _c("cargo-ag-grid", {
            key: "seGrid",
            staticStyle: { height: "470px" },
            attrs: {
              "config-module": "1100000053",
              "grid-options": _vm.se.gridOptions,
              "column-defs": _vm.seColumnDefs,
              "grid-params": _vm.gridParams,
              "row-data": _vm.finalJobs,
              "check-sub-record": false,
              "check-main-record": false,
              "deselect-main-record": false,
              "deselect-sub-record": false
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        : _vm._e(),
      _vm.lob === "SI"
        ? _c("cargo-ag-grid", {
            key: "siGrid",
            staticStyle: { height: "470px" },
            attrs: {
              "config-module": "1100000013",
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "grid-params": _vm.gridParams,
              "row-data": _vm.finalJobs
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        : _vm._e(),
      _vm.lob === "AE" || _vm.lob === "AI"
        ? _c("cargo-ag-grid", {
            key: "aeAiAiGrid",
            staticStyle: { height: "470px" },
            attrs: {
              "config-module": "1100000023",
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "grid-params": _vm.gridParams,
              "row-data": _vm.finalJobs
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        : _vm._e(),
      _vm.lob === "RE" || _vm.lob === "RI"
        ? _c("cargo-ag-grid", {
            key: "reRiGrid",
            staticStyle: { height: "470px" },
            attrs: {
              "config-module": "1100000033",
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "grid-params": _vm.gridParams,
              "row-data": _vm.finalJobs
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        : _vm._e(),
      _vm.lob === "IE"
        ? _c("cargo-ag-grid", {
            key: "ieGrid",
            staticStyle: { height: "470px" },
            attrs: {
              "config-module": "1100000043",
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "grid-params": _vm.gridParams,
              "row-data": _vm.finalJobs
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticStyle: {
            "min-height": "50px",
            height: "100%",
            position: "relative"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { position: "absolute", right: "5px" } },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "100000005",
                  total: _vm.filter.total || 0,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.loadData
                }
              })
            ],
            1
          )
        ]
      ),
      _c("sop-more-filter-dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.filterDialog.visible,
            expression: "filterDialog.visible"
          }
        ],
        ref: "filterDialog",
        attrs: {
          visible: _vm.filterDialog.visible,
          "sop-templates": _vm.templates,
          lob: _vm.lob,
          "operation-date-query-search": _vm.operationDateQuerySearch,
          "default-levels": _vm.defaultLevels
        },
        on: {
          close: function($event) {
            _vm.filterDialog.visible = false
          },
          search: _vm.handleSearch
        }
      }),
      _vm.stateDialog.visible
        ? _c("dashboard-state-dialog", {
            attrs: {
              visible: _vm.stateDialog.visible,
              rows: _vm.stateDialog.rows,
              filter: _vm.stateDialog.filter,
              "tracking-list": _vm.stateDialog.trackingList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.stateDialog, "visible", $event)
              },
              callback: function($event) {
                return _vm.loadData(true)
              }
            }
          })
        : _vm._e(),
      _vm.virtualHBLDialog.visible
        ? _c("sop-virtual-hbl-dialog", {
            attrs: {
              visible: _vm.virtualHBLDialog.visible,
              jobs: _vm.virtualHBLDialog.jobs,
              job: _vm.virtualHBLDialog.job
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.virtualHBLDialog, "visible", $event)
              },
              instructionCallback: _vm.instructionCallback
            }
          })
        : _vm._e(),
      _vm.destinationAgentSelectDialog.visible
        ? _c("destination-agent-select-dialog", {
            attrs: {
              visible: _vm.destinationAgentSelectDialog.visible,
              "row-data": _vm.destinationAgentSelectDialog.rowData,
              total: _vm.destinationAgentSelectDialog.total,
              "job-count": _vm.destinationAgentSelectDialog.jobCount
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.destinationAgentSelectDialog,
                  "visible",
                  $event
                )
              },
              callback: _vm.onSelectDestinationAgent
            }
          })
        : _vm._e(),
      _vm.checkingSendDestinationAgentWindow.visible
        ? _c("checking-send-destination-agent-window", {
            attrs: {
              visible: _vm.checkingSendDestinationAgentWindow.visible,
              "is-pass": _vm.checkingSendDestinationAgentWindow.isPass,
              "master-info": _vm.checkingSendDestinationAgentWindow.masterInfo,
              "slave-info": _vm.checkingSendDestinationAgentWindow.slaveInfo,
              "row-data": _vm.checkingSendDestinationAgentWindow.rowData,
              "show-next": _vm.checkingSendDestinationAgentWindow.showNext,
              "match-instruction-tip":
                _vm.checkingSendDestinationAgentWindow.matchInstructionTip
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.checkingSendDestinationAgentWindow,
                  "visible",
                  $event
                )
              },
              next: _vm.sendDestinationPortAgentNext
            }
          })
        : _vm._e(),
      _vm.sendDestinationPortAgentEmailMultiDialog.visible
        ? _c("send-destination-port-agent-email-multi-dialog", {
            attrs: {
              visible: _vm.sendDestinationPortAgentEmailMultiDialog.visible,
              job: _vm.sendDestinationPortAgentEmailMultiDialog.job,
              jobs: _vm.sendDestinationPortAgentEmailMultiDialog.jobs,
              "destination-agent":
                _vm.sendDestinationPortAgentEmailMultiDialog.destinationAgent,
              "mail-template-uuid":
                _vm.sendDestinationPortAgentEmailMultiDialog.mailTemplateUuid,
              "push-link":
                _vm.sendDestinationPortAgentEmailMultiDialog.pushLink,
              "tenant-instruction": _vm.currentTenantInstruction
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.sendDestinationPortAgentEmailMultiDialog,
                  "visible",
                  $event
                )
              },
              instructionCallback: _vm.instructionCallback
            }
          })
        : _vm._e(),
      _vm.lclSendDestinationPortAgentEmailDialog.visible
        ? _c("send-destination-port-agent-email-dialog", {
            attrs: {
              visible: _vm.lclSendDestinationPortAgentEmailDialog.visible,
              job: _vm.lclSendDestinationPortAgentEmailDialog.job,
              "mail-template-uuid":
                _vm.lclSendDestinationPortAgentEmailDialog.mailTemplateUuid,
              "push-link": _vm.lclSendDestinationPortAgentEmailDialog.pushLink,
              "exchange-agent-data":
                _vm.lclSendDestinationPortAgentEmailDialog.exchangeAgentData,
              "tenant-instruction": _vm.currentTenantInstruction
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.lclSendDestinationPortAgentEmailDialog,
                  "visible",
                  $event
                )
              },
              instructionCallback: _vm.instructionCallback
            }
          })
        : _vm._e(),
      _c("exchange-agent-select-dialog", {
        attrs: {
          visible: _vm.exchangeAgentSelectDialog.visible,
          "job-uuid": _vm.exchangeAgentSelectDialog.jobUuid,
          "exchange-agents": _vm.exchangeAgentSelectDialog.exchangeAgents
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.exchangeAgentSelectDialog, "visible", $event)
          },
          callback: _vm.onSelectExchangeAgent
        }
      }),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          "upload-source": _vm.UPLOAD_SOURCE_FILE_HISTORY.code,
          lob: _vm.cloudFile.lob,
          "job-uuids": _vm.cloudFile.jobUuids,
          "upload-to-job-uuids-sync": true,
          "tenant-instruction-uuid": _vm.currentTenantInstruction.uuid,
          "file-category": _vm.cloudFile.fileCategory,
          "file-category-label": _vm.cloudFile.fileCategoryLabel,
          "can-change-file-category": false
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadSuccess: _vm.instructionCallBackByUploadFile
        }
      }),
      _vm.templateSelectorDialog.visible
        ? _c("cargo-template-selector-dialog", {
            ref: "templateSelectorSupportMultiTypesDialog",
            attrs: {
              visible: _vm.templateSelectorDialog.visible,
              "template-uuids": _vm.templateSelectorDialog.templateUuids,
              "document-type-uuid": _vm.templateSelectorDialog.documentTypeUuid,
              lob: _vm.templateSelectorDialog.lob,
              job: _vm.templateSelectorDialog.job,
              data: _vm.templateSelectorDialog.data,
              "job-uuid-list": _vm.templateSelectorDialog.jobUuidList,
              "call-by-instruction": true
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
              },
              instructionCallback: _vm.instructionCallback
            }
          })
        : _vm._e(),
      _vm.instructionRecordsDialog.visible
        ? _c("instruction-records-dialog", {
            attrs: {
              visible: _vm.instructionRecordsDialog.visible,
              "row-data": _vm.instructionRecordsDialog.rowData
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.instructionRecordsDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("one-click-send-window", {
        ref: "oneClickSendWindow",
        attrs: { "file-type-caps-map": _vm.fileTypeCapsMap },
        on: { instructionCallback: _vm.onInstructionCallback }
      }),
      _c("upload-file-window", {
        ref: "uploadFileWindow",
        on: { instructionCallback: _vm.onInstructionCallback }
      }),
      _c("print-file-window", {
        ref: "printFileWindow",
        on: { instructionCallback: _vm.onInstructionCallback }
      }),
      _c("modify-state-window", {
        ref: "modifyStateWindow",
        on: {
          callback: function($event) {
            return _vm.loadData(true)
          }
        }
      }),
      _c("custom-form-window", {
        ref: "customFormWindow",
        on: { instructionCallback: _vm.onInstructionCallback }
      }),
      _c("update-job-state-window", {
        ref: "updateJobStateWindow",
        on: { instructionCallback: _vm.onInstructionCallback }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }